export default function resized (elem) {
  const event = new CustomEvent('resized', { bubbles: true })
  elem.dispatchEvent(event)
}
